import React from 'react'
import { Input } from '@driftt/tide-core'

import { curry } from 'ramda'

import './style.css'

// We're using these in place of "magic values" below
const NOW = 0
const BEGINNING_OF_TIME = null

const createRelativeDateValue = ({ from, to, timeUnit }) => ({
  rawFromValue: from,
  fromIsFutureDated: false,
  rawToValue: to,
  toIsFutureDated: false,
  timeUnit // "YEARS|MONTHS|WEEKS|DAYS|HOURS|MINUTES|SECONDS"
})

const isAfterValueFormatter = ({ value, timeUnit }) => (
  createRelativeDateValue({
    from: value,
    to: NOW,
    timeUnit
  })
)

export const IsAfterRelative = props => {  
  return <GenericRelativeDateOperator {...props} getFormattedValue={isAfterValueFormatter} />
}

const isBeforeValueFormatter = ({ value, timeUnit }) => (
  createRelativeDateValue({
    from: BEGINNING_OF_TIME,
    to: value,
    timeUnit
  })
)

export const IsBeforeRelative = props => {
  return <GenericRelativeDateOperator {...props} getFormattedValue={isBeforeValueFormatter} />
}

const genericHandleChange = curry((onChange, getFormattedValue, valueEvent) => {
  const rawValue = valueEvent.target.value
  const value = Number(rawValue)
  const timeUnit = 'DAYS'

  const formattedValue = getFormattedValue({ value, timeUnit })
  
  onChange(formattedValue, 'RELATIVE_DATE_FILTER')
})

const GenericRelativeDateOperator = ({ property, onChange, value, getFormattedValue }) => {  
  return (
    <div className="filter-builder--operators--relative-date--wrapper">
      <Input
        className="filter-builder--operators--relative-date--input"
        onChange={genericHandleChange(onChange, getFormattedValue)}
        defaultValue={value}
        type="number"
      />
      days ago
    </div>
  )
}
